import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Expand = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="expand icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.06401 6.87246L7.48443 10.2929C7.87496 10.6834 8.50812 10.6834 8.89865 10.2929L10.2929 8.89864C10.6834 8.50812 10.6834 7.87496 10.2929 7.48443L6.87246 4.064L8.24141 2.69506C8.86693 2.06954 8.42391 1 7.53929 1H1.99294C1.44455 1 1 1.44455 1 1.99294V7.5393C1 8.42391 2.06954 8.86693 2.69505 8.24141L4.06401 6.87246ZM4.06401 17.1275L7.48443 13.7071C7.87496 13.3166 8.50812 13.3166 8.89865 13.7071L10.2929 15.1014C10.6834 15.4919 10.6834 16.125 10.2929 16.5156L6.87246 19.936L8.24141 21.3049C8.86693 21.9305 8.42391 23 7.53929 23H1.99294C1.44455 23 1 22.5554 1 22.0071V16.4607C1 15.5761 2.06954 15.1331 2.69505 15.7586L4.06401 17.1275ZM16.5156 13.7071L19.936 17.1275L21.3049 15.7586C21.9305 15.1331 23 15.5761 23 16.4607V22.0071C23 22.5554 22.5554 23 22.0071 23H16.4607C15.5761 23 15.1331 21.9305 15.7586 21.3049L17.1275 19.936L13.7071 16.5156C13.3166 16.125 13.3166 15.4919 13.7071 15.1014L15.1014 13.7071C15.4919 13.3166 16.125 13.3166 16.5156 13.7071ZM19.936 6.87246L16.5156 10.2929C16.125 10.6834 15.4919 10.6834 15.1014 10.2929L13.7071 8.89864C13.3166 8.50812 13.3166 7.87496 13.7071 7.48443L17.1275 4.064L15.7586 2.69506C15.1331 2.06954 15.5761 1 16.4607 1H22.0071C22.5554 1 23 1.44455 23 1.99294V7.5393C23 8.42391 21.9305 8.86693 21.3049 8.24141L19.936 6.87246Z"
    />
  </svg>
)
